import { i18n } from '@shared/i18n';

import { StripeBalanceService } from '@modules/stripe/stripe-balance/stripe-balance-service';
import Errors from '@shared/error/errors';
import _ from 'lodash';

const balanceConfig = {
  balanceAvailable: {
    title: i18n('entities.wallet.balance.available.title'),
    emptyCaption: i18n('entities.wallet.empty'),
    borderColor: '#2acccc',
    tooltipCaption: i18n('entities.wallet.balance.available.tooltipCaption'),
    amount: 0,
    currency: 'usd'
  },
  balancePending: {
    title: i18n('entities.wallet.balance.pending.title'),
    emptyCaption: i18n('entities.wallet.empty'),
    borderColor: '#ffcd07',
    tooltipCaption: i18n('entities.wallet.balance.pending.tooltipCaption'),
    amount: 0,
    currency: 'usd'
  },
  balanceInTransit: {
    title: i18n('entities.wallet.balance.transit.title'),
    emptyCaption: i18n('entities.wallet.empty'),
    borderColor: '#788bda',
    tooltipCaption: i18n('entities.wallet.balance.transit.tooltipCaption'),
    amount: 0,
    currency: 'usd'
  },
};

const balanceTotalObject = {
  amount: 0,
  currency: 'usd'
};

export default {
  namespaced: true,

  state: {
    loading: false,
    balance: {},
    balanceTotal: {},
    connectedAccount: null,
  },

  getters: {
    loading: state => state.loading,
    balance: state => state.balance,
    balanceTotal: state => state.balanceTotal,
    balanceArray: state => Object.values(state.balance),
    connectedAccount: state => state.connectedAccount,
  },

  mutations: {
    RESET(state){
      _.update(state.balance, 'balanceAvailable.amount', () => 0);
      _.update(state.balance, 'balanceAvailable.currency', () => 'usd');

      _.update(state.balance, 'balancePending.amount', () => 0);
      _.update(state.balance, 'balancePending.currency', () => 'usd');

      _.update(state.balance, 'balanceInTransit.amount', () => 0);
      _.update(state.balance, 'balanceInTransit.currency', () => 'usd');
      
      _.update(state.balanceTotal, 'amount', () => 0);
      _.update(state.balanceTotal, 'currency', () => 'usd');
      
      state.connectedAccount = null;
    }, 

    FETCH_STARTED(state) {
      state.loading = true;
    },

    FETCH_SUCCESS(state, { balance, balanceTotal, connectedAccount }) {
      state.loading = false;
      state.balance = balance;
      state.balanceTotal = balanceTotal;
      state.connectedAccount = connectedAccount;
    },

    FETCH_EMPTY(state, { balance, balanceTotal }) {
      state.loading = false;
      state.balance = balance;
      state.balanceTotal = balanceTotal;
    }, 

    FETCH_ERROR(state) {
        state.loading = false;
        state.balance = [];
        state.balanceTotal = {};
        state.connectedAccount = null;
    },
  },

  actions: {
    async doFetch(
      { commit },
      { subpropertyId }
    ) {
      try {
        commit('RESET');

        commit('FETCH_STARTED');
        const response = await StripeBalanceService.balance(subpropertyId);
        const balance = Object.assign({}, balanceConfig);

        if (response) {
          const { balanceAvailable, balancePending, balanceInTransit, balanceTotal } = response;

          if (balanceAvailable && balanceAvailable.length > 0) {
            balance.balanceAvailable.amount = response.balanceAvailable[0].amount;
            balance.balanceAvailable.currency = response.balanceAvailable[0].currency;
          }
          if (balancePending && balancePending.length > 0) {
            balance.balancePending.amount = response.balancePending[0].amount;
            balance.balancePending.currency = response.balancePending[0].currency;
          }
          if (balanceInTransit && balanceInTransit.length > 0) {
            balance.balanceInTransit.amount = response.balanceInTransit[0].amount;
            balance.balanceInTransit.currency = response.balanceInTransit[0].currency;
          }
          if (balanceTotal && balanceTotal.length > 0) {
            balanceTotalObject.amount = response.balanceTotal[0].amount;
            balanceTotalObject.currency = response.balanceTotal[0].currency;
          }
  
          commit('FETCH_SUCCESS', { balance, balanceTotal: balanceTotalObject, connectedAccount: response.connectedAccount });
        }
        commit('FETCH_EMPTY', { balance, balanceTotal: balanceTotalObject });
      } catch (error) {
        Errors.handle(error);
        commit('FETCH_ERROR');
      }
    },

    async doPayout() {
      try {
        console.log("TODO: Create function to payout"); 
      } catch (error) {
        Errors.handle(error);
      }
    },
  },
};
